import { formatNumber, messages, plural, type Lang, type SpeedUnit } from "../i18n/index";
import { jdToDate } from "../sim/time";

const UNITS: [unit: SpeedUnit, seconds: number][] = [
  ["year", 86400 * 365.25],
  ["month", (86400 * 365.25) / 12],
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60],
  ["second", 1],
];

/** Simulated time per real second, e.g. "2.5 hours / s", or "2.5 h/s" when compact. */
export function formatSpeed(secondsPerSecond: number, lang: Lang, compact = false): string {
  const m = messages(lang).speed;
  if (secondsPerSecond === 1) return m.realTime;
  const [unit, size] = UNITS.find(([, size]) => secondsPerSecond >= size) ?? UNITS.at(-1)!;
  const value = secondsPerSecond / size;
  return compact
    ? `${formatNumber(lang, value, 1, 0)} ${m.short[unit]}/s`
    : `${plural(lang, m.units[unit], value, 1, 0)} / s`;
}

/** UTC date and time to the minute without the zone suffix, for tight layouts. */
export function formatJdCompact(jd: number): string {
  const iso = jdToDate(jd).toISOString();
  return `${iso.slice(0, 10)} ${iso.slice(11, 16)}`;
}

export function formatJd(jd: number): string {
  return `${formatJdCompact(jd)} UTC`;
}
